<template>
    <footer>lesskode, preserving your records since 2001</footer>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
footer {
    text-align: center;
    font-size: 0.5rem;
}
</style>
